/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerSadIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABVElEQVR4nN1VvU7DMBDOxAKIBUbmvgSoUyUG++6W4y4SCzwDCDVIlBGeAsRYIbVv0rdgKiAYGShyUomqiZ04YQFL32Lffd99Pv8kyb8aiLIPJE+W9ANIFzEocmQCwD0vuUV9iSWGEuTVcZUEXOXdybUA6rgk0GZbwO/ivcLBb5FrjqCAJR0OBiebFiVr0NzK2KAAM2/lcwDbdQK+2LADlMwlAslVrQNPbEwPvoD00VB6wMw7Dohy6OaWa/E9WKnuE0Ah8QyDKeUxbQUMyrlbO2LeA5QHS/LmAKT3xqS7RZ5cdHGQOXJLMiufHpnlwiTXFXnzmB4sgkCdGkr77qj6trK1gEW5DJJ2EkCdujxm3gCSO4vyvLJ+1lnAUNpf5t2uubqpdBD72PHyBq9VPgpskUxiBJKycz95Hgjcc59FS4FR8y8Tdeze85rTM/8p7Pi0EfmfHd/vj4pxJY565wAAAABJRU5ErkJggg==)
 */
export const StickerSadIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 2h12a4 4 0 0 1 4 4v7.5a.5.5 0 0 1-.5.5H19a5 5 0 0 0-5 5v2.5a.5.5 0 0 1-.5.5H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-9.8 3.83a1 1 0 0 0 1.39-.27 3.5 3.5 0 0 1 5.82 0 1 1 0 0 0 1.66-1.12 5.5 5.5 0 0 0-9.14 0 1 1 0 0 0 .27 1.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 16c.03 0 .05.03.04.06a3 3 0 0 1-.58.82l-4.24 4.24a3 3 0 0 1-.82.58.04.04 0 0 1-.06-.04V19a3 3 0 0 1 3-3h2.66Z"
        className={colorClass}
      />
    </svg>
  );
};
